module.exports = __webpack_public_path__ + "static/media/mobileicon.7a144251.svg";